module.exports = __webpack_public_path__ + "files/52d4cda7279a11c94d366562a78edd33.svg";